import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { IDocumentEngineTemplateVersion } from '@core/entities/document-engine'
import { RequestTypes } from '../requestTypes'
import { documentEngineTemplateKeys } from '../documentEngineTemplateKeys'

export const useUpdateDocumentEngineTemplateBypassStatus = (
  options?: UseMutationOptions<
    IDocumentEngineTemplateVersion,
    RequestErrorType,
    RequestTypes['updateDocumentEngineTemplateBypassStatus']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...documentEngineTemplateKeys.updateDocumentEngineTemplateBypassStatus,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: documentEngineTemplateKeys.byTemplateId({
          organisationId: variables.organisationId,
          templateId: variables.templateId,
        }).queryKey,
      })
    },
    ...options,
  })
}
